import { InphiniteThemeColors, setColorTheme } from '@facephi/ui-react';

export const getValueCustomProperties = (value: InphiniteThemeColors) => {
  return getComputedStyle(document.documentElement).getPropertyValue(
    setColorTheme(value).replace(/^var\((.+)\)$/, '$1')
  );
};
